import React from 'react';
import { Download, X } from 'lucide-react';
import { EARTH, TYPOGRAPHY } from '../theme/constants';

// Dismissible banner nudging the user toward the existing .arrlab export.
// Projects live only in localStorage — this is the cheap mitigation for the
// "cleared my browser and lost everything" support/refund scenario, until
// real cloud sync exists.
export function BackupNudge({ onExport, onDismiss }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '12px',
      padding: '10px 14px', marginBottom: '12px',
      backgroundColor: EARTH.sand[100], border: `1px solid ${EARTH.sand[300]}`,
      borderRadius: '10px', fontFamily: TYPOGRAPHY.body,
    }}>
      <span style={{ fontSize: '13px', color: EARTH.stone[700], flex: 1 }}>
        Your projects only live in this browser. Back them up so you don't lose your work.
      </span>
      <button
        onClick={onExport}
        style={{
          display: 'flex', alignItems: 'center', gap: '6px',
          padding: '6px 12px', borderRadius: '8px', border: 'none',
          backgroundColor: EARTH.terracotta[500], color: '#fff',
          fontSize: '12px', fontWeight: 600, cursor: 'pointer', fontFamily: TYPOGRAPHY.body,
          whiteSpace: 'nowrap',
        }}
      >
        <Download style={{ width: '13px', height: '13px' }} />
        Back up now
      </button>
      <button
        onClick={onDismiss}
        aria-label="Dismiss"
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '26px', height: '26px', border: 'none', background: 'transparent',
          color: EARTH.stone[400], cursor: 'pointer', flexShrink: 0,
        }}
      >
        <X style={{ width: '15px', height: '15px' }} />
      </button>
    </div>
  );
}
